/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlOnboardingActionItems = {
    UserInfoStep: 'user-info-step',
    HelloSignStep: 'hello-sign-step',
    InviteUsersStep: 'invite-users-step',
    EmployeeCountStep: 'employee-count-step',
    MspCompanyStep: 'msp-company-step',
    CompanyMspStep: 'company-msp-step',
    CheckoutPromptStep: 'checkout-prompt-step',
    SatUpsellStep: 'sat-upsell-step',
    MdrEscalationStep: 'mdr-escalation-step'
} as const;
export type ControlOnboardingActionItems = typeof ControlOnboardingActionItems[keyof typeof ControlOnboardingActionItems];


export function ControlOnboardingActionItemsFromJSON(json: any): ControlOnboardingActionItems {
    return ControlOnboardingActionItemsFromJSONTyped(json, false);
}

export function ControlOnboardingActionItemsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlOnboardingActionItems {
    return json as ControlOnboardingActionItems;
}

export function ControlOnboardingActionItemsToJSON(value?: ControlOnboardingActionItems | null): any {
    return value as any;
}

